import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly queue = new Set<number>();
  private idCounter = 0;
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);

  isLoading$ = this.loadingSubject.asObservable().pipe(distinctUntilChanged());

  show(): number {
    const id = ++this.idCounter;
    this.queue.add(id);
    this.loadingSubject.next(true);
    return id;
  }

  hide(id: number): void {
    this.queue.delete(id);
    if (this.queue.size === 0) {
      queueMicrotask(() => {
        if (this.queue.size === 0) {
          this.loadingSubject.next(false);
        }
      });
    }
  }

  reset(): void {
    this.queue.clear();
    this.loadingSubject.next(false);
  }
}
